import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import ResetPassword from "./pages/ResetPassword";
import Connexion from "../src/components/connexion/Connexion";
import Inscription from "./components/inscription/Inscription";
import Home from "./pages/Home";
import ProduitDetail from "./pages/ProduitDetail";
import Suggestion from "./pages/Suggestion";
import Compte from "./pages/Compte";
import CommandeSuivi from "./pages/Commande";
import InviteAmi from "./pages/InviteAmi";
import Informagtion from "./pages/Informagtion";
import Question from "./pages/Question";
import Confidentialite from "./pages/Confidentialite";
import Notification from "./pages/Notification";
import Paement from "./pages/Paement";
import Service from "./pages/Service";
import Livraison from "./pages/Livraison";
import SuiviCommand from "./pages/SuiviCommand";

import Boutique from "./pages/Boutique";
import Messagerie from "./pages/Messagerie";
import OrderConfirmationPaiement from "./pages/OrderConfirmationPaiement";
import BoutiquierProfile from "./components/boutiquePage/BoutiquierProfile";

import "./App.css";
import ForgetPassword from "./components/forgetPassword/ForgetPassword";
import Panier from "./pages/Panier";
import BellPage from "./pages/BellPage";
import ResusCommand from "./pages/ResusCommand";
import Homme from "./pages/Homme";
import Voir from "./pages/Voir";
import Nouveau from "./pages/Nouveau";
import Promotion from "./pages/Promotion";
import LikeProduit from "./pages/LikeProduit";
import IPayPayment from "./components/payment/IPayPayment";
import SuccessPage from "./components/payment/SuccessPage";
import ErrorPage from "./components/payment/ErrorPage";
import LoadingIndicator from "./pages/LoadingIndicator";
import axios from "axios";
import io from "socket.io-client";
import { Provider } from "react-redux";
import store from "./redux/store";
import { PanierProvider } from "./components/homePage/PanierContext";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import {
  getCategories,
  getProducts,
  getProducts_Commentes,
  getProducts_Pubs,
  getTypes,
} from "./redux/ProductsActions";
import AboutUs from "./pages/AboutUs";
import SuppliersPage from "./pages/SuppliersPage";
import AnniversaryPreview from "./pages/AnniversaryPreview";
import NigerPresencePage from "./pages/NigerPresencePage";
import ShippingPage from "./pages/ShippingPage";
import ReturnPolicyPage from "./pages/ReturnPolicyPage";
import BecomeSellerPage from "./pages/BecomeSellerPage";
import ContactPage from "./pages/ContactPage";
import AboutNigerPage from "./pages/AboutNigerPage";
import NotreEngagementPage from "./pages/NotreEngagementPage";
import CGVPage from "./pages/CGVPage";
import PolitiqueConfidentialitePage from "./pages/PolitiqueConfidentialitePage";
import SuppressionComptePage from "./pages/SuppressionComptePage";
import InscriptionWithOTP from "./components/inscription/InscriptionWithOTP";
import GoogleAuthSuccess from "./components/auth/GoogleAuthSuccess";

const BackendUrl = process.env.REACT_APP_Backend_Url;
const STRIPE_PUBLISHABLE_KEY = process.env.STRIPE_PUBLISHABLE_KEY;
// const MAINTENANCE_MODE = true;
const MAINTENANCE_MODE = false; // Set to true to enable maintenance mode 

function MaintenancePage() {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
        background:
          "radial-gradient(circle at top, rgba(255, 196, 0, 0.2), transparent 35%), linear-gradient(135deg, #101828 0%, #1d2939 45%, #0f172a 100%)",
        color: "#f8fafc",
        textAlign: "center",
      }}
    >
      <div
        style={{
          maxWidth: "720px",
          width: "100%",
          padding: "40px 28px",
          borderRadius: "28px",
          background: "rgba(15, 23, 42, 0.78)",
          border: "1px solid rgba(255, 255, 255, 0.12)",
          boxShadow: "0 24px 80px rgba(0, 0, 0, 0.35)",
          backdropFilter: "blur(14px)",
        }}
      >
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "10px",
            padding: "10px 16px",
            borderRadius: "999px",
            background: "rgba(251, 191, 36, 0.16)",
            color: "#fbbf24",
            fontSize: "14px",
            fontWeight: 700,
            letterSpacing: "0.08em",
            textTransform: "uppercase",
          }}
        >
          Maintenance en cours
        </div>

        <h1
          style={{
            margin: "24px 0 16px",
            fontSize: "clamp(2.4rem, 6vw, 4.8rem)",
            lineHeight: 1,
            fontWeight: 800,
          }}
        >
          Nous sommes en maintenance
        </h1>

        <p
          style={{
            margin: "0 auto",
            maxWidth: "560px",
            fontSize: "clamp(1rem, 2vw, 1.15rem)",
            lineHeight: 1.8,
            color: "rgba(248, 250, 252, 0.82)",
          }}
        >
          L&apos;accès au site est temporairement bloqué pendant nos travaux de
          maintenance. Merci de revenir un peu plus tard.
        </p>
      </div>
    </div>
  );
}

function App() {
  const [acces, setAcces] = useState("non");
  const [verificationComplete, setVerificationComplete] = useState(false);
  const [adminConnection, setAdminConnection] = useState(false);
  const [total, setTotal] = useState(0);
  const [codeP, setCodeP] = useState(null);
  const [produits, setProduits] = useState(0);
  const [loading, setLoading] = useState(true);
  const panier = () => {
    const local = localStorage.getItem("panier");
    if (local) {
      setProduits(JSON.parse(local));
    } else {
      setProduits(0);
    }
  };

  useEffect(() => {
    if (MAINTENANCE_MODE) {
      return;
    }

    const interceptorId = axios.interceptors.request.use((config) => {
      const requestConfig = { ...config };
      const url = requestConfig.url || "";
      const userRaw = localStorage.getItem("userEcomme");

      if (userRaw && url.startsWith(BackendUrl) && !requestConfig.headers?.Authorization) {
        try {
          const user = JSON.parse(userRaw);
          if (user?.token) {
            requestConfig.headers = {
              ...requestConfig.headers,
              Authorization: `Bearer ${user.token}`,
            };
          }
        } catch (error) {
          // Ignore malformed local storage entries and continue the request.
        }
      }

      return requestConfig;
    });

    return () => {
      axios.interceptors.request.eject(interceptorId);
    };
  }, []);

  //////////////// verification d'hautentification de l'utilisateur
  useEffect(() => {
    if (MAINTENANCE_MODE) {
      return;
    }

    const user = JSON.parse(localStorage.getItem("userEcomme"));
    panier();

    if (user) {
      axios
        .get(`${BackendUrl}/api/user/verify`, { withCredentials: true })
        .then((response) => {
          setAcces("oui");
        })
        .catch((error) => {
          setAcces("non");
          console.log(error.response);
          setVerificationComplete(true);
        })
        .finally(() => {
          setVerificationComplete(true);
        });
    } else {
      setVerificationComplete(true);
    }
  }, []);

  /////////////////// recuperation des donnees avec redux toolkit////////////////
  useEffect(() => {
    if (MAINTENANCE_MODE) {
      setLoading(false);
      return;
    }

    store.dispatch(getProducts(setLoading));
    // store.dispatch(getTypes());
    store.dispatch(getCategories(setLoading));
    store.dispatch(getProducts_Pubs());
    // store.dispatch(getProducts_Commentes());
    const socket = io(BackendUrl);

    socket.on("new_message_user", (data) => {
      // console.log("Nouveau message reçu :");
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  const changeA = (param) => {
    setAcces(param);
  };
  const stripePromise = loadStripe(
    "pk_live_51SgXbBE3LmrX4AGzOpyi2PBGkrd06DxwhblPyMCk1ma5H6DiFhx55nv9O3M3tcUlvrEMhH4dW5R0cf1fr16haHJx00gcrxUXY0"
  );
  // const stripePromise = loadStripe(
  //   "pk_live_51RKO4OFMhcWQWlbyWHqDypco5L0DrXDS4d6hEDfemzIzkzcKlodzbynkRLP2bsJGi0cxL4oy7CtJnhIGnq6tjH2A00AftfkRRQ"
  // );

    const handleAuthChange = (status) => {
    console.log('Status d\'authentification:', status);
  };

    if (MAINTENANCE_MODE) {
      return <MaintenancePage />;
    }

  return (
    <Provider store={store}>
      <PanierProvider>
        {/* <LoadingIndicator loading={loading}> */}
        <Elements stripe={stripePromise}>
          {/* <LoadingIndicator loading={false}> */}
          <LoadingIndicator loading={loading}>
            <div className="App">
              <BrowserRouter>
                <Routes>
                  <Route
                    path="/"
                    element={<Home acces={acces} paniernbr={produits} />}
                  />
                  <Route
                    path="/Connexion"
                    element={<Connexion chg={changeA} panierchg={panier} />}
                  />
                  <Route
                    path="/Inscription"
                    // element={<Inscription chg={changeA} />}
                    element={<InscriptionWithOTP chg={handleAuthChange} />}
                  />
                  <Route
                    path="/auth/google/success"
                    element={<GoogleAuthSuccess chg={changeA} />}
                  />
                  <Route
                    path="/Home"
                    element={
                      <Home
                        acces={acces}
                        paniernbr={produits}
                        panierchg={panier}
                      />
                    }
                  />
                  <Route path="/Forget Password" element={<ForgetPassword />} />
                  <Route
                    path="/ResetPassword/:email"
                    element={<ResetPassword />}
                  />
                  <Route
                    path="/ProduitDétail/:id"
                    element={
                      <ProduitDetail
                        acces={acces}
                        panierchg={panier}
                        paniernbr={produits}
                      />
                    }
                  />
                  <Route
                    path="/Panier"
                    element={
                      // acces === "oui" ? (
                      <Panier
                        acces={acces}
                        total={total}
                        setTotal={setTotal}
                        codeP={codeP}
                        setCodeP={setCodeP}
                        panierchg={panier}
                        paniernbr={produits}
                      />

                      // ) : (
                      //   <Connexion chg={changeA} />
                      // )
                    }
                  />

                  <Route
                    path="/OrderConfirmation"
                    element={
                      acces === "oui" ? (
                        <OrderConfirmationPaiement
                          acces={acces}
                          paniernbr={produits}
                          total={total}
                          codeP={codeP}
                          setCodeP={setCodeP}
                        />
                      ) : (
                        <Connexion chg={changeA} />
                      )
                    }
                  />

                  <Route
                    path="/produits"
                    element={<Homme acces={acces} paniernbr={produits} />}
                  />
                  <Route
                    path="/Compte"
                    element={
                      acces === "oui" ? (
                        <Compte acces={acces} paniernbr={produits} />
                      ) : (
                        <Connexion chg={changeA} />
                      )
                    }
                  />
                  <Route
                    path="/Like produit"
                    element={
                      acces === "oui" ? (
                        <LikeProduit acces={acces} paniernbr={produits} />
                      ) : (
                        <Connexion chg={changeA} />
                      )
                    }
                  />
                  <Route path="/ContactPage" element={<ContactPage />} />
                  <Route path="/PolitiqueConfidentialitePage" element={<PolitiqueConfidentialitePage />} />
                  <Route path="/SuppressionComptePage" element={<SuppressionComptePage />} />
                  <Route path="/CGVPage" element={<CGVPage />} />
                  <Route path="/AboutNigerPage" element={<AboutNigerPage />} />
                  <Route
                    path="/NotreEngagementPage"
                    element={<NotreEngagementPage />}
                  />

                  <Route
                    path="/Messagerie"
                    element={
                      acces === "oui" ? (
                        <Messagerie acces={acces} paniernbr={produits} />
                      ) : (
                        <Connexion chg={changeA} />
                      )
                    }
                  />

                  <Route
                    path="/Commande"
                    element={
                      acces === "oui" ? (
                        <CommandeSuivi acces={acces} paniernbr={produits} />
                      ) : (
                        <Connexion chg={changeA} />
                      )
                    }
                  />

                  <Route
                    path="/Suivre la commande/:id"
                    element={
                      acces === "oui" ? (
                        <SuiviCommand acces={acces} paniernbr={produits} />
                      ) : (
                        <Connexion chg={changeA} />
                      )
                    }
                  />

                  <Route
                    path="/Commande réisus/:id"
                    element={
                      acces === "oui" ? (
                        <ResusCommand acces={acces} paniernbr={produits} />
                      ) : (
                        <Connexion chg={changeA} />
                      )
                    }
                  />
                  {/* <Route
                path="/Suggestion"
                element={
                  acces === "oui" ? (
                    <Suggestion acces={acces} paniernbr={produits} />
                  ) : (
                    <Connexion chg={changeA} />
                  )
                }
              />
              <Route
                path="/Compte"
                element={
                  acces === "oui" ? (
                    <Compte acces={acces} paniernbr={produits} />
                  ) : (
                    <Connexion chg={changeA} />
                  )
                }
              />
              <Route
                path="/Commande"
                element={
                  acces === "oui" ? (
                    <CommandeSuivi acces={acces} paniernbr={produits} />
                  ) : (
                    <Connexion chg={changeA} />
                  )
                }
              />
              <Route
                path="/Inviter les amis"
                element={
                  acces === "oui" ? (
                    <InviteAmi acces={acces} paniernbr={produits} />
                  ) : (
                    <Connexion chg={changeA} />
                  )
                }
              />
              <Route path="/payment/ipay" element={<IPayPayment />} />
              <Route
                path="/Legal information"
                element={
                  // acces === "oui" ? (
                  <Informagtion acces={acces} paniernbr={produits} />
                  // ) : (
                  //   <Connexion chg={changeA} />
                  // )
                }
              />
              <Route
                path="/Question Fréquement possées"
                element={
                  // acces === "oui" ? (
                  <Question acces={acces} paniernbr={produits} />
                  // ) : (
                  //   <Connexion chg={changeA} />
                  // )
                }
              />
              <Route
                path="/Avis de confidentialité"
                element={
                  // acces === "oui" ? (
                  <Confidentialite acces={acces} paniernbr={produits} />
                  // ) : (
                  //   <Connexion chg={changeA} />
                  // )
                }
              />
              <Route
                path="/Paramètre de notification"
                element={
                  acces === "oui" ? (
                    <Notification acces={acces} paniernbr={produits} />
                  ) : (
                    <Connexion chg={changeA} />
                  )
                }
              />
              
              <Route
                path="/Service"
                element={
                  // acces === "oui" ? (
                  <Service acces={acces} paniernbr={produits} />
                  // ) : (
                  //   <Connexion chg={changeA} />
                  // )
                }
              />
              <Route
                path="/Livraison"
                element={
                  acces === "oui" ? (
                    <Livraison acces={acces} paniernbr={produits} />
                  ) : (
                    <Connexion chg={changeA} />
                  )
                }
              />
              <Route
                path="/Suivre la commande/:id"
                element={
                  acces === "oui" ? (
                    <SuiviCommand acces={acces} paniernbr={produits} />
                  ) : (
                    <Connexion chg={changeA} />
                  )
                }
              />
              <Route
                path="/NotificationHeader"
                element={
                  acces === "oui" ? (
                    <BellPage acces={acces} paniernbr={produits} />
                  ) : (
                    <Connexion chg={changeA} />
                  )
                }
              />
              <Route
                path="/Commande réisus/:id"
                element={
                  acces === "oui" ? (
                    <ResusCommand acces={acces} paniernbr={produits} />
                  ) : (
                    <Connexion chg={changeA} />
                  )
                }
              />
              <Route
                path="/Categorie/:name"
                element={<Homme acces={acces} paniernbr={produits} />}
              />
              <Route
                path="/Categorie/:name/:type"
                element={<Homme acces={acces} paniernbr={produits} />}
              />
              <Route path="/AboutUs" element={<AboutUs />} />
              <Route path="/SuppliersPage" element={<SuppliersPage />} />
              <Route
                path="/AnniversaryPreview"
                element={<AnniversaryPreview />}
              />
              <Route
                path="/NigerPresencePage"
                element={<NigerPresencePage />}
              />
              <Route path="/ShippingPage" element={<ShippingPage />} />
              <Route path="/ReturnPolicyPage" element={<ReturnPolicyPage />} />
              <Route path="/BecomeSellerPage" element={<BecomeSellerPage />} />
              <Route path="/ContactPage" element={<ContactPage />} />
              <Route
                path="/Voir-plus"
                element={<Voir acces={acces} paniernbr={produits} />}
              />
              <Route
                path="/Nouveau produit"
                element={<Nouveau acces={acces} paniernbr={produits} />}
              />
              <Route
                path="/Produit promotions"
                element={<Promotion acces={acces} paniernbr={produits} />}
              />
              <Route
                path="/Like produit"
                element={
                  acces === "oui" ? (
                    <LikeProduit acces={acces} paniernbr={produits} />
                  ) : (
                    <Connexion chg={changeA} />
                  )
                }
              />
              <Route
                path="/Boutique/:sellerId"
                element={<Boutique acces={acces} paniernbr={produits} />}
              />
              <Route
                path="/Messagerie"
                element={
                  acces === "oui" ? (
                    <Messagerie acces={acces} paniernbr={produits} />
                  ) : (
                    <Connexion chg={changeA} />
                  )
                }
              />
              <Route
                path="/OrderConfirmation"
                element={
                  acces === "oui" ? (
                    <OrderConfirmationPaiement
                      acces={acces}
                      paniernbr={produits}
                      total={total}
                      codeP={codeP}
                      setCodeP={setCodeP}
                    />
                  ) : (
                    <Connexion chg={changeA} />
                  )
                }
              />
              <Route
                path="/Profile d'un boutiquier/:sellerId"
                element={
                  <BoutiquierProfile acces={acces} paniernbr={produits} />
                }
              />
              <Route path="/success" element={<SuccessPage />} />
              <Route path="/error" element={<ErrorPage />} /> */}
                </Routes>
              </BrowserRouter>
            </div>
          </LoadingIndicator>
        </Elements>
      </PanierProvider>
    </Provider>
  );
}

export default App;
